module.exports = __webpack_public_path__ + "media/country_flags/zw-42ffbf51.png";